import { render, staticRenderFns } from "./EventView.vue?vue&type=template&id=c44ff35e&scoped=true&"
import script from "./EventView.vue?vue&type=script&lang=js&"
export * from "./EventView.vue?vue&type=script&lang=js&"
import style0 from "./EventView.vue?vue&type=style&index=0&id=c44ff35e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44ff35e",
  null
  
)

export default component.exports